/* eslint-disable max-lines */
import { defineMessages } from 'react-intl';

export default defineMessages({
  progress: {
    id: 'app.containers.PropertyAssessment.progress',
    defaultMessage: '{current} de {total}',
  },
  close: {
    id: 'app.containers.PropertyAssessment.close',
    defaultMessage: 'Fechar',
  },
  back: {
    id: 'app.containers.PropertyAssessment.back',
    defaultMessage: 'Voltar',
  },
  help: {
    id: 'app.containers.PropertyAssessment.help',
    defaultMessage: 'Ajuda',
  },
  helpTooltip: {
    id: 'app.containers.PropertyAssessment.helpTooltip',
    defaultMessage: 'Caso tenha dúvidas de como avaliar esse item',
  },
  continue: {
    id: 'app.containers.PropertyAssessment.continue',
    defaultMessage: 'Continuar',
  },
  finish: {
    id: 'app.containers.PropertyAssessment.finish',
    defaultMessage: 'Concluir',
  },
  comment: {
    id: 'app.containers.PropertyAssessment.comment',
    defaultMessage: 'Conte quais são os outros cômodos:',
  },
  commentHint: {
    id: 'app.containers.PropertyAssessment.commentHint',
    defaultMessage: 'Separe os cômodos com vírgulas',
  },
  electricalTitle: {
    id: 'app.containers.PropertyAssessment.electricalTitle',
    defaultMessage: 'Instalações elétricas',
  },
  electricalDescription: {
    id: 'app.containers.PropertyAssessment.electricalDescription',
    defaultMessage:
      'Nesta etapa você vai avaliar a conservação e o funcionamento de itens elétricos.',
  },
  electricalIsWorking: {
    id: 'app.containers.PropertyAssessment.electricalIsWorking',
    defaultMessage: 'O imóvel tem energia?',
  },
  fuseboxTitle: {
    id: 'app.containers.PropertyAssessment.fuseboxTitle',
    defaultMessage: 'Quadro de energia',
  },
  fuseboxConservation: {
    id: 'app.containers.PropertyAssessment.fuseboxConservation',
    defaultMessage: 'Como você avalia a conservação?',
  },
  lightTitle: {
    id: 'app.containers.PropertyAssessment.lightTitle',
    defaultMessage: 'Luminárias',
  },
  lightIsWorking: {
    id: 'app.containers.PropertyAssessment.lightIsWorking',
    defaultMessage: 'Todas as luminárias/luzes estão acendendo?',
  },
  lightConservation: {
    id: 'app.containers.PropertyAssessment.lightConservation',
    defaultMessage:
      'Que opção representa melhor a conservação de todas as luminárias?',
  },
  lightDefectiveIn: {
    id: 'app.containers.PropertyAssessment.lightDefectiveIn',
    defaultMessage: 'Em quais cômodos as luminárias/luzes não estão acendendo?',
  },
  switchSocketTitle: {
    id: 'app.containers.PropertyAssessment.switchSocketTitle',
    defaultMessage: 'Tomadas',
  },
  switchSocketConservation: {
    id: 'app.containers.PropertyAssessment.switchSocketConservation',
    defaultMessage:
      'Que opção representa melhor a conservação de todas as tomadas?',
  },
  hydraulicTitle: {
    id: 'app.containers.PropertyAssessment.hydraulicTitle',
    defaultMessage: 'Instalações hidráulicas',
  },
  hydraulicDescription: {
    id: 'app.containers.PropertyAssessment.hydraulicDescription',
    defaultMessage:
      'Nesta etapa você vai avaliar a conservação e o funcionamento de itens hidráulicos.',
  },
  hydraulicIsWorking: {
    id: 'app.containers.PropertyAssessment.hydraulicIsWorking',
    defaultMessage: 'O imóvel tem abastecimento de água?',
  },
  registerTitle: {
    id: 'app.containers.PropertyAssessment.registerTitle',
    defaultMessage: 'Registros',
  },
  registerIsWorking: {
    id: 'app.containers.PropertyAssessment.registerIsWorking',
    defaultMessage: 'Todos os registros estão funcionando?',
  },
  registerConservation: {
    id: 'app.containers.PropertyAssessment.registerConservation',
    defaultMessage:
      'Que opção representa melhor a conservação de todos os registros?',
  },
  registerDefectiveIn: {
    id: 'app.containers.PropertyAssessment.registerDefectiveIn',
    defaultMessage: 'Em quais cômodos os registros não estão funcionando?',
  },
  toiletTitle: {
    id: 'app.containers.PropertyAssessment.toiletTitle',
    defaultMessage: 'Vasos sanitários',
  },
  toiletIsWorking: {
    id: 'app.containers.PropertyAssessment.toiletIsWorking',
    defaultMessage: 'Todas os vasos sanitários estão funcionando?',
  },
  toiletConservation: {
    id: 'app.containers.PropertyAssessment.toiletConservation',
    defaultMessage:
      'Que opção representa melhor a conservação de todos os vasos sanitários?',
  },
  valveTitle: {
    id: 'app.containers.PropertyAssessment.valveTitle',
    defaultMessage: 'Válvulas de descarga',
  },
  valveIsWorking: {
    id: 'app.containers.PropertyAssessment.valveIsWorking',
    defaultMessage: 'Todas as válvulas de descarga estão funcionando?',
  },
  valveConservation: {
    id: 'app.containers.PropertyAssessment.valveConservation',
    defaultMessage:
      'Que opção representa melhor a conservação de todas as válvulas de descarga?',
  },
  sinkTitle: {
    id: 'app.containers.PropertyAssessment.sinkTitle',
    defaultMessage: 'Pias ou cubas',
  },
  sinkConservation: {
    id: 'app.containers.PropertyAssessment.sinkConservation',
    defaultMessage:
      'Que opção representa melhor a conservação de todas as pias ou cubas?',
  },
  faucetTitle: {
    id: 'app.containers.PropertyAssessment.faucetTitle',
    defaultMessage: 'Torneiras',
  },
  faucetIsWorking: {
    id: 'app.containers.PropertyAssessment.faucetIsWorking',
    defaultMessage: 'Todas as torneiras estão funcionando?',
  },
  faucetConservation: {
    id: 'app.containers.PropertyAssessment.faucetConservation',
    defaultMessage:
      'Que opção representa melhor a conservação de todas as torneiras?',
  },
  faucetDefectiveIn: {
    id: 'app.containers.PropertyAssessment.faucetDefectiveIn',
    defaultMessage: 'Em quais cômodos as torneiras não estão funcionando?',
  },
  siphonTailTitle: {
    id: 'app.containers.PropertyAssessment.siphonTailTitle',
    defaultMessage: 'Sifões das pias',
  },
  siphonTailConservation: {
    id: 'app.containers.PropertyAssessment.siphonTailConservation',
    defaultMessage:
      'Que opção representa melhor a conservação de todos os sifões das pias?',
  },
  showerTitle: {
    id: 'app.containers.PropertyAssessment.showerTitle',
    defaultMessage: 'Chuveiros',
  },
  showerIsWorking: {
    id: 'app.containers.PropertyAssessment.showerIsWorking',
    defaultMessage: 'Todos os chuveiros estão funcionando?',
  },
  showerConservation: {
    id: 'app.containers.PropertyAssessment.showerConservation',
    defaultMessage:
      'Que opção representa melhor a conservação de todos os chuveiros?',
  },
  structureTitle: {
    id: 'app.containers.PropertyAssessment.structureTitle',
    defaultMessage: 'Estrutura física',
  },
  structureDescription: {
    id: 'app.containers.PropertyAssessment.structureDescription',
    defaultMessage:
      'Nesta etapa você vai avaliar a conservação e o funcionamento de itens da estrutura física.',
  },
  wallTitle: {
    id: 'app.containers.PropertyAssessment.wallTitle',
    defaultMessage: 'Paredes',
  },
  wallConservation: {
    id: 'app.containers.PropertyAssessment.wallConservation',
    defaultMessage:
      'Que opção representa melhor a conservação de todas as paredes?',
  },
  ceilingTitle: {
    id: 'app.containers.PropertyAssessment.ceilingTitle',
    defaultMessage: 'Teto',
  },
  ceilingConservation: {
    id: 'app.containers.PropertyAssessment.ceilingConservation',
    defaultMessage:
      'Que opção representa melhor a conservação do teto do imóvel?',
  },
  floorTitle: {
    id: 'app.containers.PropertyAssessment.floorTitle',
    defaultMessage: 'Pisos',
  },
  floorConservation: {
    id: 'app.containers.PropertyAssessment.floorConservation',
    defaultMessage:
      'Que opção representa melhor a conservação de todos os pisos?',
  },
  doorLockTitle: {
    id: 'app.containers.PropertyAssessment.doorLockTitle',
    defaultMessage: 'Portas e fechaduras',
  },
  doorLockIsWorking: {
    id: 'app.containers.PropertyAssessment.doorLockIsWorking',
    defaultMessage: 'Todas as portas e fechaduras estão funcionando?',
  },
  doorLockConservation: {
    id: 'app.containers.PropertyAssessment.doorLockConservation',
    defaultMessage:
      'Que opção representa melhor a conservação de todas as portas e fechaduras?',
  },
  doorLockDefectiveIn: {
    id: 'app.containers.PropertyAssessment.doorLockDefectiveIn',
    defaultMessage:
      'Em quais cômodos as portas e fechaduras não estão funcionando?',
  },
  windowTitle: {
    id: 'app.containers.PropertyAssessment.windowTitle',
    defaultMessage: 'Janelas',
  },
  windowIsWorking: {
    id: 'app.containers.PropertyAssessment.windowIsWorking',
    defaultMessage: 'Todas as janelas estão funcionando?',
  },
  windowConservation: {
    id: 'app.containers.PropertyAssessment.windowConservation',
    defaultMessage:
      'Que opção representa melhor a conservação de todas as janelas?',
  },
  windowDefectiveIn: {
    id: 'app.containers.PropertyAssessment.windowDefectiveIn',
    defaultMessage: 'Em quais cômodos as janelas não estão funcionando?',
  },
  propertyItemsTitle: {
    id: 'app.containers.PropertyAssessment.propertyItemsTitle',
    defaultMessage: 'Itens do imóvel',
  },
  propertyItemsDescription: {
    id: 'app.containers.PropertyAssessment.propertyItemsDescription',
    defaultMessage:
      'Nesta etapa você vai avaliar a conservação e o funcionamento de itens do imóvel.',
  },
  intercomTitle: {
    id: 'app.containers.PropertyAssessment.intercomTitle',
    defaultMessage: 'Interfone',
  },
  intercomIsWorking: {
    id: 'app.containers.PropertyAssessment.intercomIsWorking',
    defaultMessage: 'Todos os interfones estão funcionando?',
  },
  intercomConservation: {
    id: 'app.containers.PropertyAssessment.intercomConservation',
    defaultMessage:
      'Que opção representa melhor a conservação de todos os interfones?',
  },
  bathroomStallTitle: {
    id: 'app.containers.PropertyAssessment.bathroomStallTitle',
    defaultMessage: 'Boxes dos banheiros',
  },
  bathroomStallIsWorking: {
    id: 'app.containers.PropertyAssessment.bathroomStallIsWorking',
    defaultMessage: 'Todos os boxes dos banheiros estão funcionando?',
  },
  bathroomStallConservation: {
    id: 'app.containers.PropertyAssessment.bathroomStallConservation',
    defaultMessage:
      'Que opção representa melhor a conservação de todos os boxes dos banheiros?',
  },
  bathroomCabinetTitle: {
    id: 'app.containers.PropertyAssessment.bathroomCabinetTitle',
    defaultMessage: 'Armários do banheiro',
  },
  bathroomCabinetIsWorking: {
    id: 'app.containers.PropertyAssessment.bathroomCabinetIsWorking',
    defaultMessage: 'Todos os armários do banheiro estão funcionando?',
  },
  bathroomCabinetConservation: {
    id: 'app.containers.PropertyAssessment.bathroomCabinetConservation',
    defaultMessage:
      'Que opção representa melhor a conservação de todos os armários dos chuveiros?',
  },
  bedroomClosetTitle: {
    id: 'app.containers.PropertyAssessment.bedroomClosetTitle',
    defaultMessage: 'Armários do quarto',
  },
  bedroomClosetIsWorking: {
    id: 'app.containers.PropertyAssessment.bedroomClosetIsWorking',
    defaultMessage: 'Todos os armários do quarto estão funcionando?',
  },
  bedroomClosetConservation: {
    id: 'app.containers.PropertyAssessment.bedroomClosetConservation',
    defaultMessage:
      'Que opção representa melhor a conservação de todos os armários do quarto?',
  },
  kitchenCabinetTitle: {
    id: 'app.containers.PropertyAssessment.kitchenCabinetTitle',
    defaultMessage: 'Armários da cozinha',
  },
  kitchenCabinetIsWorking: {
    id: 'app.containers.PropertyAssessment.kitchenCabinetIsWorking',
    defaultMessage: 'Todos os armários da cozinha estão funcionando?',
  },
  kitchenCabinetConservation: {
    id: 'app.containers.PropertyAssessment.kitchenCabinetConservation',
    defaultMessage:
      'Que opção representa melhor a conservação de todos os armários da cozinha?',
  },
  yes: {
    id: 'app.containers.PropertyAssessment.yes',
    defaultMessage: 'Sim',
  },
  no: {
    id: 'app.containers.PropertyAssessment.no',
    defaultMessage: 'Não',
  },
  noAnswer: {
    id: 'app.containers.PropertyAssessment.noAnswer',
    defaultMessage: 'Não foi possível avaliar',
  },
  bedroom: {
    id: 'app.containers.PropertyAssessment.bedroom',
    defaultMessage: 'Quarto',
  },
  livingRoom: {
    id: 'app.containers.PropertyAssessment.livingRoom',
    defaultMessage: 'Sala',
  },
  serviceArea: {
    id: 'app.containers.PropertyAssessment.serviceArea',
    defaultMessage: 'Área de serviço',
  },
  bathroom: {
    id: 'app.containers.PropertyAssessment.bathroom',
    defaultMessage: 'Banheiro',
  },
  kitchen: {
    id: 'app.containers.PropertyAssessment.kitchen',
    defaultMessage: 'Cozinha',
  },
  other: {
    id: 'app.containers.PropertyAssessment.other',
    defaultMessage: 'Outros',
  },
  needsRepair: {
    id: 'app.containers.PropertyAssessment.needsRepair',
    defaultMessage: 'Precisa de troca ou reparo imediato',
  },
  manySignsOfUse: {
    id: 'app.containers.PropertyAssessment.manySignsOfUse',
    defaultMessage: 'Com muitas marcas de uso',
  },
  fewSignsOfUse: {
    id: 'app.containers.PropertyAssessment.fewSignsOfUse',
    defaultMessage: 'Com leves marcas de uso',
  },
  newItem: {
    id: 'app.containers.PropertyAssessment.newItem',
    defaultMessage: 'Novo, sem marcas de uso',
  },
  saveItemError: {
    id: 'app.containers.PropertyAssessment.saveItemError',
    defaultMessage:
      'Ocorreu um erro ao salvar informações. Tente novamente, mais tarde.',
  },
  confirmTitle: {
    id: 'app.containers.PropertyAssessment.confirmTitle',
    defaultMessage: 'Deseja concluir a avaliação do imóvel?',
  },
  confirmDescription: {
    id: 'app.containers.PropertyAssessment.confirmDescription',
    defaultMessage: 'Depois de concluída, a avaliação não pode ser editada',
  },
  confirmBackAction: {
    id: 'app.containers.PropertyAssessment.confirmBackAction',
    defaultMessage: 'Não, voltar',
  },
  confirmFinishAction: {
    id: 'app.containers.PropertyAssessment.confirmFinishAction',
    defaultMessage: 'Sim, concluir',
  },
  loadingTitle: {
    id: 'app.containers.PropertyAssessment.loadingTitle',
    defaultMessage: 'Carregando informações…',
  },
  loadingDescription: {
    id: 'app.containers.PropertyAssessment.loadingDescription',
    defaultMessage:
      'Sincronizando as últimas informações registradas por você.',
  },
  alertHelpDescription: {
    id: 'app.containers.PropertyAsessment.alertHelpDescription',
    defaultMessage: 'Tem dúvidas sobre como avaliar?',
  },
  alertHelpLink: {
    id: 'app.containers.PropertyAssessment.alertHelpLink',
    defaultMessage: 'Veja a explicação',
  },
});
